// src/constants/logPermissions.js
export const LOG_PERMISSIONS = {
    SUPER_ADMIN: {
      label: 'Super Admin',
      permissions: ['READ', 'DELETE', 'EXPORT', 'VIEW_SENSITIVE', 'VIEW_FORENSIC']
    },
    ADMIN_INSTITUICAO: {
      label: 'Admin Instituição',
      permissions: ['READ_INSTITUTION']
    },
    AUDITOR_INTERNO: {
      label: 'Auditor Interno',
      permissions: ['READ_INSTITUTION', 'EXPORT_INSTITUTION', 'VIEW_SENSITIVE_INSTITUTION']
    }
  };
  
  export const LOG_ACTIONS = {
    CREATE: 'CRIAR',
    UPDATE: 'ATUALIZAR',
    DELETE: 'EXCLUIR',
    READ: 'CONSULTAR',
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    EXPORT: 'EXPORTAR'
  };
  
  export const LOG_ENTITIES = {
    USER: 'USUARIO',
    INSTITUTION: 'INSTITUICAO',
    STUDENT: 'ESTUDANTE',
    COURSE: 'CURSO',
    CLASS: 'CLASSE',
    PAYMENT: 'PAGAMENTO'
  };